import { ConfigAutoplayPolicy, GlobalConfig } from './configSchema';

/** Global config for CLIPr App and widgets. */
export const Config: GlobalConfig = {
  auth: {
    minPasswordLength: 8,

    storageIdTokenExpiresKey: 'auth.idToken.expires',
    storageIsAuthenticatedKey: 'auth.isAuthenticated',
    storageForceConnectionKey: 'auth.forceConnection',

    connections: {
      Default: {
        enabled: true,
        auth0: {
          connection: 'Password-Authentication',
        },
      },

      Google: {
        enabled: true,
        showSocialLoginButton: true,
        auth0: {
          connection: 'google-oauth2',
        },
      },

      Facebook: {
        enabled: true,
        showSocialLoginButton: true,
        auth0: {
          connection: 'facebook',
        },
      },

      LinkedIn: {
        enabled: true,
        showSocialLoginButton: true,
        auth0: {
          connection: 'linkedin',
        },
      },

      Twitter: {
        enabled: true,
        showSocialLoginButton: true,
        auth0: {
          connection: 'twitter',
        },
      },

      Microsoft: {
        enabled: true,
        showSocialLoginButton: true,
        auth0: {
          connection: 'windowslive',
        },
      },

      'External:Poly': {
        enabled: true,
        allowForcing: true,
        auth0: {
          connection: import.meta.env.VITE_AUTH0_EXTERNAL_POLY_CONNECTION!,
        },
      },
    },

    auth0: {
      domain: import.meta.env.VITE_AUTH0_CUSTOM_DOMAIN_NAME!,
      clientId: import.meta.env.VITE_AUTH0_WEB_APP_CLIENT_ID!,
      responseType: 'token id_token',
      defaultConnection: 'Default',
      redirectUrlDataMaxOutputLength: 512,
      redirectUrlDataKey: 'data',
    },
  },

  player: {
    liveStreamEndedMessageDelta: 60,
    autoplayPolicy: ConfigAutoplayPolicy.Standard,
  },

  routing: {
    maxUrlLength: 2000,
    storageKeyPrefix: 'routing.',
    redirect: {
      lastPrivatePathKey: 'rdlpp',
      authFlowKey: 'rdaf',
    },
  },

  liveFeedPage: {
    activeStreamTooltipMessage:
      'Select "Backup feed" if your Primary feed is running less efficiently than expected.',
  },

  agencySignup: {
    enabled: import.meta.env.VITE_AGENCY_SIGNUP_ENABLED === 'true',
  },

  speakerId: {
    autoTriggerSpeakerIdFlow:
      !import.meta.env.VITE_SPEAKER_TEAM_SCOPE_ENABLE ||
      import.meta.env.VITE_SPEAKER_TEAM_SCOPE_ENABLE === 'undefined',
    speakerIdConfirmationMessage:
      !import.meta.env.VITE_SPEAKER_TEAM_SCOPE_ENABLE ||
      import.meta.env.VITE_SPEAKER_TEAM_SCOPE_ENABLE === 'undefined'
        ? `You are about to identify this person in this video, adding their name to CLIPr's global database of speakers. This will help CLIPr identify speakers automatically in future videos.`
        : 'You are about to identify this person in this video. This will help CLIPr identify speakers automatically in future videos.',
  },

  storage: {
    testKey: 'STORAGE_TEST_KEY',
    testValue: 'STORAGE_TEST_VALUE',
  },

  vendor: {
    react: {
      useStrictMode: false,
    },

    googleImaSdk: {
      url: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
    },

    textEditor: {
      apiKey:
        'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MDE4NzE5OTksImp0aSI6IjMzMjcyY2Q2LTI0YWMtNDA0NC1iYWQ5LTU1ZTE5MDg0ZjBhYiIsImxpY2Vuc2VkSG9zdHMiOlsiMTI3LjAuMC4xIiwibG9jYWxob3N0IiwiMTkyLjE2OC4qLioiLCIxMC4qLiouKiIsIjE3Mi4qLiouKiIsIioudGVzdCIsIioubG9jYWxob3N0IiwiKi5sb2NhbCJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sImxpY2Vuc2VUeXBlIjoiZGV2ZWxvcG1lbnQiLCJmZWF0dXJlcyI6WyJEUlVQIiwiRTJQIiwiRTJXIl0sInJlbW92ZUZlYXR1cmVzIjpbIlBCIiwiUkYiLCJTQ0giLCJUQ1AiLCJUTCIsIlRDUiIsIklSIiwiU1VBIiwiQjY0QSIsIkxQIiwiSEUiLCJSRUQiLCJQRk8iLCJXQyIsIkZBUiIsIkJLTSIsIkZQSCIsIk1SRSJdLCJ2YyI6ImFlYjk3YTUzIn0.RT7sFxxTIKLJJ-4uxT-OFu2K55-SZ034Z_Ss2ufeMJmQdzIUOLCPFqXF9g4IpAEnISlYdSKAq3CxPopYOOurrg',
    },
  },

  debug: {
    // IMPORTANT! If you're reviewing this and it's set to `true`,
    // notify the person who left it like this to fix it (probably Tibi)
    // because it should always be set to `false` (or `process.env.NODE_ENV !== 'production'`) before merging
    // we will move this to env variables at some point

    enable: false,
    trace: false,
    traceFilter: [],
  },
};
